import React from 'react';
import { NO_BIZ_FOUND } from '../../constants/urls';
import { Container,Header,Details } from './styles';

const NoBusiness = () => (
        <Container>
            <img src={NO_BIZ_FOUND} alt=""/>
            <Header>Add a business to proceed</Header>
            <Details>
            <span>Please add a business by visiting</span>
            <span><strong>einv.cleartax.in</strong> from your desktop</span>
            <span> to view its invoices & reports from this app.</span>
            </Details>
        </Container>
    );

export default NoBusiness
